import React from 'react';
import {
  SummaryItem,
  MoodBadge,
  ApproachSection,
} from './ChatSummaryComponents';

interface ChatSummaryProps {
  parsedData: any;
  showResumen: boolean;
  onToggle: () => void;
}

export const ChatSummary: React.FC<ChatSummaryProps> = ({
  parsedData,
  showResumen,
  onToggle,
}) => {
  if (!parsedData || Object.keys(parsedData).length === 0) return null;

  return (
    <div className='sticky top-0 z-20 mb-6'>
      <div className='bg-white p-4 rounded-xl border border-blue-100 shadow-md'>
        <div
          className='flex items-center justify-between cursor-pointer mb-2'
          onClick={onToggle}
        >
          <h3 className='text-[10px] font-bold text-blue-600 uppercase tracking-[0.2em]'>
            RESUMEN DEL CHAT
          </h3>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={2.5}
            stroke='currentColor'
            className={`w-3 h-3 text-blue-400 transition-transform duration-300 ${showResumen ? 'rotate-180' : ''}`}
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='m19.5 8.25-7.5 7.5-7.5-7.5'
            />
          </svg>
        </div>

        <div
          className={`transition-all duration-300 overflow-hidden ${showResumen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
        >
          <div className='grid grid-cols-2 gap-x-8 gap-y-3 text-sm pt-2 overflow-hidden'>
            <SummaryItem
              label='Pedido'
              value={parsedData?.pedido}
              valueColor='text-blue-500'
            />
            <SummaryItem
              label='Usuario'
              value={parsedData?.usuario}
              valueColor='text-emerald-500'
            />
            <SummaryItem
              label='Tienda'
              value={parsedData?.tienda}
              valueColor='text-indigo-500'
            />

            <p className='flex items-start gap-2 overflow-hidden'>
              <strong className='text-gray-900 shrink-0'>Motivo:</strong>
              <span className='text-rose-500 text-xs leading-relaxed line-clamp-2'>
                {parsedData?.motivo || 'N/A'}
              </span>
            </p>

            <MoodBadge
              emoji={parsedData?.estado_animo?.emoji}
              description={parsedData?.estado_animo?.descripcion}
            />

            <ApproachSection content={parsedData?.abordaje} />
          </div>
        </div>
      </div>
    </div>
  );
};
